var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.221 17.7971L30.7207 3.54852C29.2763 2.30118 27 3.31377 27 5.25139V12.7564C11.941 12.9288 0 15.9468 0 30.218C0 35.9781 3.71072 41.6845 7.81247 44.6679C9.09244 45.5989 10.9166 44.4304 10.4447 42.9212C6.19369 29.3263 12.461 25.7171 27 25.5079V33.7499C27 35.6906 29.2781 36.6987 30.7207 35.4528L47.221 21.2028C48.2589 20.3064 48.2604 18.6948 47.221 17.7971Z"
  })));
};
export default SvgShare;